import _ from 'lodash';

/**
 * 树深度优先遍历
 * @param node 树节点或节点数组
 * @param callback 遍历回调函数，返回 false 时终止遍历
 * @param childrenFn 子节点获取函数, 默认使用 _.get(node, 'children', [])
 */
export function treeEach<T>(
    node: T | T[],
    callback: (node: T, level: number, parentPath: T[] /* 父节点路径, 逐级变深 */) => boolean | void,
    childrenFn: (node: T) => T[] = (node: T) => _.get(node, 'children', []),
) {
    if (node) {
        const iterator = (nodes: T[], level: number, parentPath: T[]) => {
            let ifContinue;
            _.forEach(nodes, node => {
                // 支持提前结束, 如果返回 false 则提前结束
                ifContinue = callback(node, level, parentPath);
                if (ifContinue === false) return false;
                const children = childrenFn(node);
                if (children && children.length) {
                    ifContinue = iterator(children, level + 1, _.concat(parentPath, node));
                    return ifContinue;
                }
            });
            return ifContinue;
        };
        const nodes: T[] = [];
        iterator(nodes.concat(node), 1, []);
    }
}

/** 从树中按深度优先遍历查找节点 */
export function treeFind<T>(
    node: T | T[],
    callback: (node: T, level: number) => boolean | void,
    childrenFn?: (node: T) => T[],
) {
    let rt: T | undefined;
    treeEach(node, (node, level) => {
        if (callback(node, level)) {
            rt = node;
            return false;
        }
    }, childrenFn);
    return rt;
}
